'use strict';

exports.__esModule = true;
exports.RichText = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ = require('../..');

var _2 = _interopRequireDefault(_);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var RichText = exports.RichText = (_temp = _class = function (_EditorComponent) {
  _inherits(RichText, _EditorComponent);

  function RichText(props) {
    _classCallCheck(this, RichText);

    var _this = _possibleConstructorReturn(this, _EditorComponent.call(this, props));

    _this.onChangeEditor = _this.onChangeEditor.bind(_this);
    return _this;
  }

  RichText.prototype.renderPanelView = function renderPanelView(content) {
    var _getEditorContext = this.getEditorContext(),
        classes = _getEditorContext.classes;

    return _EditorComponent.prototype.renderPanelView.call(this, content || _react2.default.createElement('div', {
      className: classes.panelButton
    }, 'RichText'));
  };

  RichText.prototype.canBeChild = function canBeChild(child) {
    return false;
  };

  RichText.prototype.onChangeEditor = function onChangeEditor(value) {
    // const {
    //   inEditMode,
    // } = this.getEditorContext();
    this.updateComponentProps({
      content: value
    });
  };

  RichText.prototype.isEditorReadOnly = function isEditorReadOnly() {
    var _getObjectWithMutatio = this.getObjectWithMutations(),
        readOnly = _getObjectWithMutatio.props.readOnly;

    if (readOnly === undefined) {
      var _getEditorContext2 = this.getEditorContext(),
          inEditMode = _getEditorContext2.inEditMode;

      readOnly = !inEditMode;
    }

    return readOnly;
  };

  RichText.prototype.renderChildren = function renderChildren() {
    var Editor = this.context.Editor;

    var _getComponentProps = this.getComponentProps(this),
        content = _getComponentProps.content; // const {
    //   activeItem,
    //   inEditMode,
    // } = this.getEditorContext();


    var readOnly = this.isEditorReadOnly();
    return _react2.default.createElement(Editor, {
      value: content,
      readOnly: readOnly,
      onChange: this.onChangeEditor
    });
  };

  return RichText;
}(_2.default), _class.Name = 'RichText', _class.defaultProps = _extends({}, _2.default.defaultProps, {
  hide_wrapper_in_default_mode: true
}), _temp);
exports.default = RichText;